export const generateMultiSectionKey = ({ index, sectionName }) =>
  `${sectionName}${index > 1 ? `-${index}` : ""}`;
